export default "__VITE_ASSET__CnWwu_FB__"